import { actions } from "./actions";
import { mutations } from "./mutations";
import { getters } from "./getters";

const state = {
    parents: [],
    individu: {},
    medecin : undefined,
    maladies:[],
    autorisations :  [],
    allergies:[],
    vaccins:[],
    famille_champs: [],
    individu_champs: [],
    champs_libres: [],
    champ_libre_valeur: [],
    Champ_libre_result_valeur: [],
    information_individu: [],
    dossier: {},

}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}